import { EBillingPeriodType } from "../../Enum/EBillingPeriodType"

export class SubscriptionPlanPeriodPricing {
  planEntityId: number

  planPeriodEntityId: number

  periodType: EBillingPeriodType

  price: number

  constructor(data: Partial<SubscriptionPlanPeriodPricing> = {}) {
    this.planEntityId = data.planEntityId ?? 0

    this.planPeriodEntityId = data.planPeriodEntityId ?? 0

    this.periodType = data.periodType ?? EBillingPeriodType.Monthly

    this.price = data.price ?? 0
  }
}
